import { Link } from 'react-router-dom';
import { getDiscount } from '../../utils/functions';
import DeleteIcon from '@mui/icons-material/Delete';
import StarIcon from '@mui/icons-material/Star';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { removeFromWishlist } from '../../actions/wishlistAction';
import { addItemsToCart, removeItemsFromCart } from '../../actions/cartAction';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useLang, uiText } from '../../utils/i18n';

const Product = (props) => {

    const { product, name, price, cuttedPrice, image, ratings, reviews, stock } = props;

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { lang } = useLang();

    const { cartItems } = useSelector((state) => state.cart);
    const cartItem = cartItems.find((i) => i.product === product);

    const deleteHandler = () => {
        dispatch(removeFromWishlist(product));
    }

    const addToCartHandler = () => {
        if (stock < 1) {
            enqueueSnackbar(uiText('productOutOfStock', lang), { variant: "error" });
            return;
        }
        dispatch(addItemsToCart(product, 1));
        enqueueSnackbar(uiText('addedToCart', lang), { variant: "success" });
    }

    const increaseQty = () => {
        if (cartItem.quantity >= stock) {
            enqueueSnackbar(uiText('noMoreStock', lang), { variant: "warning" });
            return;
        }
        dispatch(addItemsToCart(product, cartItem.quantity + 1));
    }

    const decreaseQty = () => {
        if (cartItem.quantity <= 1) {
            dispatch(removeItemsFromCart(product));
            return;
        }
        dispatch(addItemsToCart(product, cartItem.quantity - 1));
    }

    return (
        <div className="flex gap-4 border-b p-4 sm:pb-8 w-full group overflow-hidden">
            <div className="w-1/6 h-28 flex-shrink-0">
                <img draggable="false" className="h-full w-full object-contain" src={image} alt={name} />
            </div>

            {/* <!-- description --> */}
            <div className="flex flex-col gap-5 w-full p-1">
                {/* <!-- product title --> */}
                <div className="flex justify-between items-start sm:pr-5">
                    <Link to={`/product/${product}`} className="flex flex-col gap-0.5">
                        <p className="group-hover:text-primary-blue w-56 sm:w-full truncate">{name.length > 85 ? `${name.substring(0, 85)}...` : name}</p>
                        {/* <!-- rating badge --> */}
                        <span className="text-sm text-gray-500 font-medium flex gap-2 items-center">
                            <span className="text-xs px-1.5 py-0.5 bg-primary-green rounded-sm text-white flex items-center gap-0.5">{ratings} <StarIcon sx={{ fontSize: "14px" }} /></span>
                            <span>({reviews.toLocaleString()})</span>
                        </span>
                        {/* <!-- rating badge --> */}
                    </Link>
                    <button onClick={deleteHandler} className="text-gray-400 hover:text-red-500"><span><DeleteIcon /></span></button>
                </div>
                {/* <!-- product title --> */}

                {/* <!-- price desc --> */}
                <div className="flex items-center gap-2 text-2xl font-medium">
                    <span>HK${price.toLocaleString()}</span>
                    <span className="text-sm text-gray-500 line-through font-normal mt-1">HK${cuttedPrice.toLocaleString()}</span>
                    <span className="text-sm text-primary-green mt-1">{getDiscount(price, cuttedPrice)}%&nbsp;{uiText('offLabel', lang)}</span>
                </div>
                {/* <!-- price desc --> */}

                {/* <!-- add to cart / qty stepper --> */}
                {stock < 1 ? (
                    <span className="text-xs text-red-500 font-medium">{uiText('outOfStock', lang)}</span>
                ) : cartItem ? (
                    <div className="flex items-center justify-between border border-primary-blue rounded-sm w-28 overflow-hidden">
                        <button onClick={decreaseQty} className="flex-1 py-1 text-primary-blue hover:bg-blue-50 flex justify-center"><RemoveIcon sx={{ fontSize: "16px" }} /></button>
                        <span className="text-sm font-medium">{cartItem.quantity}</span>
                        <button onClick={increaseQty} className="flex-1 py-1 text-primary-blue hover:bg-blue-50 flex justify-center"><AddIcon sx={{ fontSize: "16px" }} /></button>
                    </div>
                ) : (
                    <button onClick={addToCartHandler} className="border border-primary-blue text-primary-blue text-xs font-medium uppercase px-4 py-1.5 rounded-sm hover:bg-primary-blue hover:text-white w-28">
                        {uiText('addBtn', lang)}
                    </button>
                )}
                {/* <!-- add to cart / qty stepper --> */}

            </div>
            {/* <!-- description --> */}
        </div>
    );
};

export default Product;